import React, { Component } from 'react'
import { connect } from 'react-redux'

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { getMenuObjects } from '../utils/utils';
import { setB2bComapny } from '../redux/actions/histogram';
import { push } from '../components/routerPatch';

class HeaderTabs extends Component {
    handleChange = (event, newValue) => {
        const { dispatch } = this.props
        dispatch(push('/' + newValue));
    }

    handleChangeB2bCompany = (event, newValue) => {
        const { dispatch } = this.props
        dispatch(setB2bComapny(newValue))
        //dispatch(push('/' + newValue + 'Clients'));
    }

    render() {
        const {histogramType, isAuthed, userInfo, isFetching, hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec, isJobHunt, b2bList, b2bCompany} = this.props;        
        const isRecruiter = (isAuthed && userInfo.lookingforwork === false)
        const menuObject = getMenuObjects(isAuthed, isRecruiter, isJobHunt)
        const tabsValue = (menuObject.allowedValues.includes(histogramType)) ? histogramType : false 

        const isBusiness = (window.VIEW_TYPE === 'business')

        let hideBadge = true

        if (isAuthed && userInfo){
            if (userInfo.lookingforwork){
                hideBadge = !(hasJobsSuggestion || hasMatchesCan)
            } else {
                hideBadge = !(hasApplicants || hasMatchesRec)
            }
        }

        return (
            <React.Fragment>
                {isBusiness?<>
                    {(b2bList.length>1)&&<Tabs value={b2bCompany} onChange={this.handleChangeB2bCompany} classes={{ indicator: "mainTabIndicator" }}>
                        {b2bList.map(tab => 
                            <Tab key={tab} label={<span>{tab}</span>}
                                value={tab} className="headerTab" classes={{ selected: "selected"}} disabled={isFetching}/>
                        )}
                    </Tabs>}
                </>:
                <Tabs value={tabsValue} onChange={this.handleChange} classes={{ indicator: "mainTabIndicator" }}>
                    {menuObject.allowedMenus.map(tab => 
                            <Tab key={tab.value} label={<span>{tab.label}{(tab.value === 'activity' && !hideBadge)&&<div style={{right:3}} className="JSBadge"></div>}</span>}
                                value={tab.value} className="headerTab" classes={{ selected: "selected"}} disabled={isFetching}/>
                    )}
                </Tabs>}
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    const { isAuthed, userInfo } = state.authUser;
    const histogramType = state.histogramData.histogramType;
    const isFetching = state.histogramJobs.isFetching
    const {hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec} = userInfo

    const b2bList = state.histogramData.b2bList || []
    const b2bCompany = state.histogramData.b2bCompany || ''

    return {
        isAuthed, userInfo, histogramType, isFetching, hasJobsSuggestion, hasMatchesCan, hasApplicants, hasMatchesRec, b2bList, b2bCompany
    }
}

export default connect(mapStateToProps)(HeaderTabs)